<div class="container-loading">
  <div class="container-icons">
    <object
      type="image/svg+xml"
      data="../../../../../assets/img/svg/train-loader.svg"
    ></object>
  </div>
</div>
